import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Quote = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Icon">
        <g id="Group">
          <path
            id="Vector"
            d="M6 2H1.5C0.673 2 0 2.673 0 3.5V8C0 8.827 0.673 9.5 1.5 9.5H3.5185L2.7595 13.4045C2.7015 13.7025 2.9475 14 3.25 14H4.87C5.305 14 5.691 13.7155 5.823 13.3035L7.278 9.851C7.2865 9.831 7.2935 9.811 7.2995 9.791C7.4325 9.3115 7.5 8.816 7.5 8.3185V3.5C7.5 2.673 6.827 2 6 2ZM6.5 8.3185C6.5 8.7155 6.4475 9.1105 6.344 9.4925L4.891 12.94C4.88272 12.9595 4.87571 12.9796 4.87 13H3.8565L4.6155 9.095C4.62859 9.02277 4.62577 8.94856 4.60725 8.87753C4.58873 8.80651 4.55495 8.74037 4.50826 8.68373C4.46157 8.62709 4.40309 8.58131 4.3369 8.54958C4.27071 8.51785 4.1984 8.50093 4.125 8.5H1.5C1.2245 8.5 1 8.2755 1 8V3.5C1 3.2245 1.2245 3 1.5 3H6C6.2755 3 6.5 3.2245 6.5 3.5V8.3185ZM14.5 2H10C9.173 2 8.5 2.673 8.5 3.5V8C8.5 8.827 9.173 9.5 10 9.5H12.0185L11.2595 13.405C11.201 13.705 11.4445 14 11.75 14H13.37C13.805 14 14.1915 13.7155 14.3225 13.3035L15.7785 9.851C15.7865 9.831 15.7935 9.811 15.7995 9.7905C15.9325 9.311 16 8.8155 16 8.3185V3.5C16 2.673 15.327 2 14.5 2ZM15 8.3185C15 8.715 14.9475 9.1095 14.8435 9.4925L13.3905 12.9395C13.3825 12.9595 13.376 12.9795 13.3705 13H12.3565L13.1155 9.095C13.1285 9.02278 13.1256 8.94861 13.1071 8.87761C13.0885 8.80662 13.0547 8.74052 13.008 8.68391C12.9614 8.62729 12.9029 8.58151 12.8368 8.54975C12.7706 8.51799 12.6984 8.50102 12.625 8.5H10C9.724 8.5 9.5 8.2755 9.5 8V3.5C9.5 3.2245 9.724 3 10 3H14.5C14.776 3 15 3.2245 15 3.5V8.3185Z"
          />
        </g>
      </g>
    </svg>
  );
};

Quote.displayName = 'Quote';
